var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBedDouble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "lucide lucide-bed-double-icon lucide-bed-double",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 20v-8a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 10V6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 4v6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2 18h20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBedDouble);
export default __webpack_public_path__ + "static/media/bed-double.bf1d2b25fc3db7c613c99ed8d575d676.svg";
export { ForwardRef as ReactComponent };